var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jira__Property 1=Jira",
    className: "jira__Property jira__1=Jira"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jira__Integrations",
    className: "jira__Integrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jira__Group 214",
    className: "jira__Group jira__214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jira__Vector",
    fill: "#2684FF",
    d: "M23.222 11.777 12.99 1.639 12 .656 4.297 8.288.775 11.777a.93.93 0 0 0 0 1.318l7.036 6.973L12 24.216l7.7-7.632.12-.118 3.403-3.365a.934.934 0 0 0 .278-.662.927.927 0 0 0-.278-.662Zm-11.223 4.142-3.516-3.483L12 8.953l3.514 3.483L12 15.919Z",
    className: "jira__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jira__Vector_2",
    fill: "url(#jira__paint0_linear_16058_193807)",
    d: "M11.998 8.955a5.837 5.837 0 0 1-1.734-4.128 5.836 5.836 0 0 1 1.709-4.14L4.28 8.308l4.186 4.148 3.532-3.5Z",
    className: "jira__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jira__Vector_3",
    fill: "url(#jira__paint1_linear_16058_193807)",
    d: "m15.522 12.426-3.524 3.493a5.838 5.838 0 0 1 1.733 4.147 5.838 5.838 0 0 1-1.733 4.147l7.714-7.64-4.19-4.147Z",
    className: "jira__Vector"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira__paint0_linear_16058_193807",
    x1: 11.369,
    x2: 6.504,
    y1: 5.431,
    y2: 10.339,
    className: "jira__paint0_linear_16058",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira__paint1_linear_16058_193807",
    x1: 12.669,
    x2: 17.524,
    y1: 19.401,
    y2: 14.502,
    className: "jira__paint1_linear_16058",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.0b9ed7269912adf10051a3230eba34a5.svg";
export { ForwardRef as ReactComponent };